module.exports = __webpack_public_path__ + "static/media/elephant.df84be2d.svg";